import React from 'react'

const LinkedInChannelForm = ({ dataItem, onChange }) => {
    return (
        <>
            <div className='col-6 mt-2'>
                <label htmlFor="accountId">Account ID *</label>
                <input
                    type="text"
                    name="accountId"
                    className='form-control form-control-sm'
                    placeholder="Enter Account ID"
                    value={dataItem.accountId}
                    onChange={onChange}
                />
            </div>
            <div className='col-6 mt-2'>
                <label htmlFor="client_id">Client ID *</label>
                <input
                    type="password"
                    name="client_id"
                    placeholder="Enter Client ID"
                    className='form-control form-control-sm'
                    value={dataItem.client_id}
                    onChange={onChange}
                />
            </div>
            <div className='col-6 mt-2'>
                <label htmlFor="client_secret">Client Secret *</label>
                <input
                    type="password"
                    name="client_secret"
                    className='form-control form-control-sm'
                    placeholder="Enter Client Secret"
                    value={dataItem.client_secret}
                    onChange={onChange}
                />
            </div>
            <div className='col-6 mt-2'>
                <label htmlFor="accessToken">Access Token</label>
                <input
                    type="password"
                    name="accessToken"
                    className='form-control form-control-sm'
                    placeholder="Enter Access Token"
                    value={dataItem.accessToken}
                    onChange={onChange}
                />
            </div>
            <div className="col-12 mt-3">
                <label className="fw-bold">How to get your LinkedIn Ads API credentials:</label>
                <div className='row p-2 border rounded overflow-auto' style={{ maxHeight: '250px' }}>
                    <div className="col-6">
                        <ol className="small mt-2">
                            <li>
                                <strong>Organization ID:</strong>
                                <ul>
                                    <li>Go to <a href="https://www.linkedin.com/developers/" target="_blank" rel="noreferrer">LinkedIn Developers</a> and log in.</li>
                                    <li>Click on "My Apps" and select your app.</li>
                                    <li>Under "Products", ensure "Marketing Developer Platform" is added and approved.</li>
                                    <li>Your Organization ID can be found by visiting your LinkedIn Business Manager or via API.</li>
                                </ul>
                            </li>
                            <li className="mt-2">
                                <strong>Client ID & Client Secret:</strong>
                                <ul>
                                    <li>Go to the LinkedIn Developer Portal and open your app.</li>
                                    <li>Under the "Auth" tab, you'll find your Client ID and Client Secret.</li>
                                    <li>Ensure your app has the required OAuth permissions like `r_ads`, `rw_organization_admin`, `rw_ads`.</li>
                                </ul>
                            </li>
                        </ol>
                    </div>
                    <div className="col-6">
                        <ol start="3" className="small mt-2">
                            <li>
                                <strong>Access Token:</strong>
                                <ul>
                                    <li>Use the LinkedIn OAuth 2.0 flow to generate an access token.</li>
                                    <li>You can use tools like Postman or the LinkedIn OAuth 2.0 Playground to test authentication.</li>
                                    <li>More info in the <a href="https://learn.microsoft.com/en-us/linkedin/shared/authentication/authorization-code-flow" target="_blank" rel="noreferrer">LinkedIn Auth Docs</a>.</li>
                                    <li>Token usually expires in 60 days unless refreshed.</li>
                                </ul>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LinkedInChannelForm